import parse from "html-react-parser";

import ProductContentSection from "./components/ProductContentSection";
import TestedFeaturesReadOnlyList from "./components/TestedFeaturesReadOnlyList";
import VendorInformationSection from "./components/VendorInformationSection";

const ProductContent = ({ project }: any) => {
  if (!project) return;

  return (
    <>
      <ProductContentSection title="PRODUCT DESCRIPTION">
        {parse(project.product_description)}
      </ProductContentSection>

      <ProductContentSection title="EVALUATED CONFIGURATION">
        {parse(project.evaluation_configuration)}
      </ProductContentSection>

      <ProductContentSection title="SECURITY EVALUATION SUMMARY">
        {parse(project.security_evaluation_summary)}
      </ProductContentSection>

      <ProductContentSection title="ENVIRONMENTAL STRENGTHS">
        {parse(project.environmental_strengths)}
      </ProductContentSection>

      <TestedFeaturesReadOnlyList features={project.features} />

      <VendorInformationSection project={project} />
    </>
  );
};
export default ProductContent;
